import { Link, } from 'react-router-dom'
import { useAgegate } from 'hooks/use-agegate';
import Button from 'components/button';
import textServices from 'services/text-services';
import { Section } from './style/section';
import { TitleEnd, SubTitleEnd } from './style/text';

function EndRoute() {

  const { removeAge } = useAgegate();

  return (
    <Section className="flex-1 py-0 mx-7 flex flex-col items-center din large-screen-padding" style={{ maxHeight: 1080 }}>
      <article className="flex-1 flex flex-col justify-center items-center text-center uppercase">
        <TitleEnd className="font-bold text-4xl uppercase text-center mb-6">{textServices.findByText('endroute/title', <>¡Lo sentimos! <br /> Esto es solo para mayores</>)}</TitleEnd>
        <SubTitleEnd className="text-base text-center font-medium">{textServices.findByText('endroute/description', 'Vuelve cuando seas más grande.')}</SubTitleEnd>
      </article>
      <Link to="/agegate" className="w-full mb-8">
        <Button
          onClick={() => {
            gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'END ROUTE - Menor de 18', value: '10' })
            removeAge()
          }}
        >
          {textServices.findByText('endroute/button', 'VOLVER')}
        </Button>
      </Link>
    </Section>
  )
}

export default EndRoute
